import React from 'react';

import {LLBtn2, withCommon} from '../../components';

const EasyMembershipResult = withCommon({
    store: ({store}) => ({
        viewSize: store.site.status.viewSize,
        closeModal: store.modal.close,
        openPersonalInfoForm: store.user.openPersonalInfoForm,
        success: store.modal.currentKey === 'easy-membership-success',
    }),
    defaultName: 'EasyMembershipResult',
    isObserver: true,
    isTrans: true,
})(({trans, viewSize, closeModal, openPersonalInfoForm, success}) => (
    <div className={`easy-membership-prompt easy-membership-prompt--${viewSize}`}>
        <h2 className="easy-membership-prompt__title">
            {success
                ? trans('Your Information Has Been Successfully Saved')
                : trans('Identity Information Could Not Be Verified')}
        </h2>
        {success ? (
            <LLBtn2
                customClasses={`easy-membership-prompt__cta ll-btn--accent`}
                onClick={() => closeModal()}
            >
                {trans('OK')}
            </LLBtn2>
        ) : (
            <LLBtn2
                customClasses={`easy-membership-prompt__cta ll-btn--accent`}
                onClick={() => {
                    closeModal();
                    openPersonalInfoForm();
                }}
            >
                {trans('TRY AGAIN')}
            </LLBtn2>
        )}
    </div>
));

export default EasyMembershipResult;
